import {default as format} from './format';

const sum = (accounts) => {
    if (!accounts) return 0;
    return format(accounts.map((account) => account.balance).reduce((acc, val) => acc + val, 0));
};

export default sum;
